import TrashOutlineIcon from '@eduzz/houston-icons/TrashOutline';
import UploadIcon from '@eduzz/houston-icons/Upload';
import { IconButton, List, ListItem, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Spin from 'components/Spin';
import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import uploadService from 'v2/services/upload';

import { useStyles } from './styles';
import { FormContent } from '../../EditProduct/components/FormContent';

import type { FileWithPath } from 'react-dropzone';

interface IProps {
  onUpload: (upload_id: number) => void;
  onRemove: () => void;
}

export const PrivateLabelRights = ({ onUpload, onRemove }: IProps) => {
  const classes = useStyles();
  const [file, setFile] = useState<FileWithPath>();
  const [uploading, setUploading] = useState<boolean>(false);

  const onDrop = (files: FileWithPath[]) => {
    const f = [...files].shift();
    onUploadFile(f);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
  });

  const onUploadFile = useCallback(
    (file) => {
      setUploading(true);
      uploadService
        .uploadFile(file, 'private_label_rights')
        .then((response: { data: { upload_id: number } }) => {
          setFile(file);
          onUpload(response.data.upload_id);
          setUploading(false);
        })
        .catch(() => {
          toast.error('Falha ao subir arquivo, tente novamente');
          setFile(null);
          setUploading(false);
        });
    },
    [onUpload]
  );

  const handleRemove = () => {
    setFile(null);
    onRemove();
  };

  return (
    <FormContent title='Direitos privados de etiqueta' loading={false}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Alert severity='warning'>
            <p>
              Caso o conteúdo não seja de sua autoria, para que o seu conteúdo seja aprovado, é preciso preencher{' '}
              <a
                href='https://drive.google.com/file/d/0B49AZsMzd09sU3YxU3BXYUliZGc/view?resourcekey=0-3uLUHC6Oatpm7UguZ1kN3A'
                target='_blank'
                rel='noopener noreferrer'
              >
                este documento
              </a>{' '}
              e anexar no campo ao lado. Caso você seja o autor deste conteúdo, pode pular esta etapa.
            </p>
            <br />
            <p>
              <strong>Por que preciso fazer isso?</strong>
            </p>
            <br />
            <p>
              Você pode conferir{' '}
              <a
                href='https://ajuda.eduzz.com/hc/pt-br/articles/7986263370267-Como-cadastrar-um-produto-que-autoriza-ou-utiliza-a-imagem-de-outra-pessoa-'
                target='_blank'
                rel='noopener noreferrer'
              >
                este artigo
              </a>{' '}
              explicando todos os detalhes.
            </p>
          </Alert>
        </Grid>
        <Grid item xs={12} md={6}>
          {!uploading && file && (
            <>
              <h4>Arquivo</h4>
              <List>
                <ListItem key={file.lastModified} className={classes.item}>
                  <ListItemText>{file.name}</ListItemText>
                  <ListItemSecondaryAction>
                    <IconButton onClick={handleRemove}>
                      <TrashOutlineIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </>
          )}
          {!file && (
            <div id='drag-and-drop-plr' {...getRootProps({ className: classes.dropzone })}>
              {uploading && <Spin message={'Por favor aguarde, estamos fazendo upload do arquivo.'} />}
              {!uploading && (
                <>
                  <input {...getInputProps()} />
                  <UploadIcon />
                  <p>Selecione ou arraste seu arquivo de PLR (Direitos Privados de Etiqueta)</p>
                </>
              )}
            </div>
          )}
        </Grid>
      </Grid>
    </FormContent>
  );
};
